__turbopack_context__.v({
  "ctaCard": "pro-vs-air-client-module__hw6Tyq__ctaCard",
  "ctaCardImage": "pro-vs-air-client-module__hw6Tyq__ctaCardImage",
  "ctaCardPrice": "pro-vs-air-client-module__hw6Tyq__ctaCardPrice",
  "ctaCardTitle": "pro-vs-air-client-module__hw6Tyq__ctaCardTitle",
  "ctaInner": "pro-vs-air-client-module__hw6Tyq__ctaInner",
  "ctaSection": "pro-vs-air-client-module__hw6Tyq__ctaSection",
  "ctaUnavailable": "pro-vs-air-client-module__hw6Tyq__ctaUnavailable",
  "heroSection": "pro-vs-air-client-module__hw6Tyq__heroSection",
  "heroSubtitle": "pro-vs-air-client-module__hw6Tyq__heroSubtitle",
  "heroTitle": "pro-vs-air-client-module__hw6Tyq__heroTitle",
});
